import Data from './Data.vue';
import Menu from "./Menu.vue";
import Header from "./Header.vue";
import Carousel from "./Carousel.vue";
import EmbedVideo from "./EmbedVideo.vue";
import ReadMore from "./ReadMore.vue";
import Frames from "./tileblock/animation/Frames.vue";
import Form from "./Form.vue";
import Field from "./Field.vue";
import ImagesUploader from "./uploader/ImagesUploader.vue";
import Upload from "./Upload.vue";
import Confirm from "./Confirm.vue";
import Hover from "./Hover.vue";
import OstendeRegisterVenue from "./ostende/RegisterVenue.vue";
import OstendeRegisterCompany from "./ostende/RegisterCompany.vue";
import OstendeArtisticFieldsLabel from "./ostende/ArtisticFieldsLabel.vue";
import OstendeEditDirectoryCard from "./ostende/EditDirectoryCard.vue";
import OstendePerformanceForm from "./ostende/PerformanceForm.vue";
import OstendeVenuesAutocomplete from "./ostende/VenuesAutocomplete.vue";
import OstendeCompanyAgenda from "./ostende/agenda/CompanyAgenda.vue";
import OstendeAgenda from "./ostende/agenda/Agenda.vue";
import OstendeJobOffers from "./ostende/jobs/JobOffers.vue";
import OstendeEditJobOffer from "./ostende/jobs/EditJobOffer.vue";
import OstendeJobOfferItem from "./ostende/jobs/JobOfferItem.vue";
import OstendeRoomAvailabilities from "./ostende/room-availabilities/RoomAvailabilities.vue";
import EditableList from "./EditableList.vue";
import CursusFeedbackForm from "./cursus/FeedbackForm.vue";
import SizeObserver from "./SizeObserver.vue";
import PostalCodeCity from "./ekip/PostalCodeCity.vue";
import LexiconDefinition from "./LexiconDefinition.vue";
import BreadcrumbDropdown from "./BreadcrumbDropdown.vue";
import BreadcrumbDropdownToggle from "./BreadcrumbDropdownToggle.vue";
import ReadMoreLineclamp from "./ReadMoreLineclamp.vue";


export default {
    'v-data': Data,
    'aca-menu': Menu,
    'aca-header': Header,
    'aca-carousel': Carousel,
    'aca-embed-video': EmbedVideo,
    'aca-read-more': ReadMore,
    'aca-read-more-lineclamp': ReadMoreLineclamp,
    'aca-frames': Frames,
    'aca-form': Form,
    'aca-field': Field,
    'aca-images-uploader': ImagesUploader,
    'aca-upload': Upload,
    'aca-confirm': Confirm,
    'aca-hover': Hover,
    'aca-breadcrumb-dropdown': BreadcrumbDropdown,
    'aca-breadcrumb-dropdown-toggle': BreadcrumbDropdownToggle,
    'aca-lexicon-definition': LexiconDefinition,
    OstendeRegisterVenue,
    OstendeRegisterCompany,
    OstendeArtisticFieldsLabel,
    OstendeEditDirectoryCard,
    OstendePerformanceForm,
    OstendeVenuesAutocomplete,
    OstendeCompanyAgenda,
    OstendeAgenda,
    OstendeJobOffers,
    OstendeEditJobOffer,
    OstendeJobOfferItem,
    OstendeRoomAvailabilities,
    OstendeSearch: () => ({
        component: import(/* webpackChunkName: 'ostende-search', webpackPreload: true */'./ostende/search/Search.vue'),
        loading: { functional: true, render: (h, ctx) => ctx.scopedSlots.default() },
    }),
    EditableList,
    CursusFeedbackForm,
    'size-observer': SizeObserver,
    'postal-code-city': PostalCodeCity,
}
